// @flow

import * as React from 'react';

import classNames from '@ta/common.classnames';
import KeyboardEventListener from '@ta/events.keyboard-event-listener';
import { Link } from '@ta/common.routing';
import { BlockScroll } from '@ta/modal.core';
import { POIObjectList } from '@ta/social.poi';
import { ContentDisplayDate } from '@ta/social.dates';
import { Linkify } from '@ta/social.links';
import { Avatar } from '@ta/styleguide.avatar';
import { InteractionLogger } from '@ta/tracking.interactions';
import { SectionOverflowMenu } from '@ta/social.section-overflow';
import styles from './VideoSidebar.less';

type Props = {|
  actor: any,
  video: any,
  deleteObject: ?() => void,
  untagObject?: ?() => void,
  onClose?: (e?: SyntheticEvent<*>) => void,
  loggedInUserId?: string,
  socialStatisticsBar?: React.Node,
  socialActionBar?: React.Node,
|};

// TODO this is copied from UntagAction.jsx
const DisplayUntagIcon = (item: any, currentUserId?: string) =>
  item &&
  currentUserId &&
  item.socialReferences &&
  item.socialReferences.userReferences &&
  item.socialReferences.userReferences.find(o => o.userId === currentUserId);

const VideoSidebar = ({
  video,
  actor,
  deleteObject,
  untagObject,
  onClose,
  loggedInUserId,
  socialStatisticsBar,
  socialActionBar,
}: Props) => {
  const pois = video.object.orderedLocations;

  const overrideItems =
    actor && !actor.isMe
      ? {
          FOLLOW: true,
          UNTAG: !!DisplayUntagIcon(video.object, loggedInUserId),
        }
      : {
          FOLLOW: false,
          UNTAG: !!DisplayUntagIcon(video.object, loggedInUserId),
        };

  const displayDate = video.object.publishedDate || video.object.uploadDate;

  return (
    <React.Fragment>
      <div className={`ui_column is-4 is-3-widescreen is-12-mobile ${styles.modal_info}`}>
        <div className={`${styles.section} ${styles.sidebar}`}>
          <div className={styles.member_block}>
            <InteractionLogger>
              {logUserClick => (
                <React.Fragment>
                  <div className={styles.member_block_left}>
                    <Link
                      to={{ page: 'Profile', username: actor.username }}
                      className={styles.avatar_wrap}
                      onClick={e => logUserClick(e, 'userClick', { userId: actor.userId })}
                    >
                      <Avatar
                        photo={actor.avatar}
                        display="inline"
                        withBorder
                        onClick={e => logUserClick(e, 'userClick', { userId: actor.userId })}
                      />
                    </Link>
                    <span className={styles.member_wrap}>
                      <Link
                        to={{ page: 'Profile', username: actor.username }}
                        className={classNames(styles.member_name, {
                          verified: actor.isVerified,
                        })}
                        onClick={e => logUserClick(e, 'userClick', { userId: actor.userId })}
                      >
                        {actor.displayName}
                      </Link>
                      <span className={styles.event_date}>
                        <ContentDisplayDate dateStr={displayDate} />
                      </span>
                    </span>
                  </div>
                  <div className={styles.member_block_right}>
                    <SectionOverflowMenu
                      sectionObject={video.object}
                      sectionActor={actor}
                      deleteObject={deleteObject}
                      untagObject={untagObject}
                      overrideItems={overrideItems}
                    />
                  </div>
                </React.Fragment>
              )}
            </InteractionLogger>
          </div>

          {video.object.caption && (
            <div className={styles.caption}>
              <Linkify
                text={video.object.caption}
                socialReferences={video.object.socialReferences}
              />
            </div>
          )}
          {socialStatisticsBar}
          {socialActionBar}
        </div>
        {pois && pois[0] && <POIObjectList pois={pois} showSavesIcon />}
      </div>
      <React.Fragment>
        <div
          className={styles.close}
          onClick={event => {
            if (onClose) {
              onClose(event);
            }
          }}
        />
        <KeyboardEventListener
          keyName="Escape"
          callback={() => {
            if (onClose) {
              onClose();
            }
          }}
        />
        <BlockScroll />
      </React.Fragment>
    </React.Fragment>
  );
};

VideoSidebar.defaultProps = {
  onClose: undefined,
  loggedInUserId: '',
  untagObject: null,
};

export default VideoSidebar;
